// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"admin/components/FontAwesomePreviewModal","234":"common/components/EditUserModal","485":"common/components/SearchModal","852":"admin/components/ResetExtensionSettingsModal"}[chunkId] + ".js";
};